import { useCompany } from '@/context/companies'
import { isSimpleNationalCompany } from '@/helpers'
import { Company } from '@/types'
import { Alert, Stack } from '@mui/material'

const messageSx = {
  '& .MuiAlert-message': {
    fontSize: { xs: '0.875rem', md: '1rem' },
    lineHeight: 1.5,
  },
}

function recurringGuidesDisclaimer(company?: Company | null) {
  const guides = !company?.tax_regime
    ? null
    : isSimpleNationalCompany(company)
      ? 'DAS, DARF e TFE'
      : 'ISS, PIS/COFINS, IRPJ/CSLL e DARF'
  const examples = guides ? ` (${guides})` : ''

  return `Aqui você encontra as guias da sua empresa pelo vencimento. As recorrentes${examples} aparecem a partir de setembro/2026, junto com parcelamentos, retenções e boletos avulsos.`
}

export function TaxGuidesDisclaimers() {
  const { company } = useCompany()

  return (
    <Stack spacing={1.5} mb={2}>
      <Alert icon={false} severity="info" sx={messageSx}>
        {recurringGuidesDisclaimer(company)}
      </Alert>
      <Alert icon={false} severity="warning" sx={messageSx}>
        A marcação “Você já pagou?” serve apenas para o seu controle e não
        confirma a baixa do pagamento na Receita Federal ou na Prefeitura. Em
        até 90 dias, verificaremos o pagamento junto ao órgão responsável e
        avisaremos você caso haja alguma divergência ou pendência.
      </Alert>
    </Stack>
  )
}
